export const lang = {
  "loading": {
    "a1": "로딩 중...",
    "a2": "더 이상 데이터가 없습니다",
    "a3": "구독 처리 중...",
    "a4": "결제 진행 중...",
    "a5": "제출 중...",
    "a6": "환매 처리 중..."
  },
  "tabbar": {
    "a1": "홈",
    "a2": "포지션",
    "a3": "시장",
    "a4": "자산",
    "a5": "내 정보"
  },
  "basic": {
    "a1": "언어 변경",
    "a2": "확인",
    "a3": "취소"
  },
  "notifyPopup": {
    "a3": "확인"
  },
  "gywm": {
    "a1": "회사 소개",
    "a2": "회사 개요",
    "a3": "개인정보 처리방침",
    "a4": "서비스 / 이용약관"
  },
  "yssm": {
    "a1": "1. 목적 및 범위",
    "a2": "본 정책은 플랫폼 이용 중 사용자(개인 또는 법인)의 개인정보({value})를 보호하는 것을 목적으로 합니다.",
    "a3": "본 정책은 계좌 개설, 거래, 고객 지원 및 백엔드 운영을 포함하여 본 플랫폼 및 관련 웹사이트/시스템을 통해 제출되거나 처리되는 모든 개인정보에 적용됩니다.",
    "a4": "2. 데이터 수집 및 처리 유형",
    "a5": "수집 및 처리될 수 있는 정보에는 다음이 포함되며 이에 국한되지 않습니다:",
    "a6": "신원 정보:",
    "a7": "성명, 신분증/여권 번호 또는 기타 정부 발급 신분증, 생년월일, 납세자 번호(해당 시) 등",
    "a8": "연락처 정보:",
    "a9": "주소, 이메일, 전화번호 등",
    "a10": "계좌 및 금융 정보:",
    "a11": "은행 또는 결제 계좌 정보, 재무 상태, 거래 내역, 자금의 출처/사용, 자산 및 부채 등",
    "a13": "사용 및 접근 데이터:",
    "a14": "IP 주소, 디바이스 정보, 브라우저 유형, 로그인 기록, 쿠키/추적 ID, 거래 행동, 선호도 및 사용 습관 등",
    "a15": "기타 자발적 제공 정보:",
    "a16": "위험 고지 정보, 컴플라이언스 문서, 인증 자료, 커뮤니케이션 기록 등",
    "a17": "3. 데이터 처리 목적 및 법적 근거",
    "a18": "데이터는 다음 목적을 위해 수집 및 처리될 수 있습니다:",
    "a19": "거래 서비스 제공, 계좌 관리 및 고객 지원;",
    "a20": "관련 법률 및 규정 준수(자금세탁방지 AML, 신원 인증, 세무 준수, 증권 규정 등);",
    "a21": "사기, 자금세탁, 플랫폼 남용 및 보안 위협 방지;",
    "a22": "시스템 및 서비스의 보안성과 안정성 유지 및 개선;",
    "a23": "사용자 동의 하에 마케팅, 공지 및 상품/서비스 홍보에 활용;",
    "a24": "법적 근거에는 사용자 동의, 계약 이행의 필요성, 법적/규제 의무가 포함됩니다.",
    "a25": "4. 제3자 처리 및 국제 데이터 이전",
    "a26": "데이터가 제3자(결제 처리업체, 신원 인증 서비스 제공자, 클라우드 서비스 등)에 이전되는 경우, 플랫폼은 계약 목적에 한해 사용되도록 보장하고 적절한 데이터 처리 계약을 체결합니다.",
    "a27": "데이터가 아르헨티나 외부로 이전되는 경우, 적절한 기술적·조직적·계약적 보호 조치가 적용됩니다.",
    "a28": "5. 데이터 보관",
    "a29": "개인정보는 관련 목적 달성, 법적/규제 요구 준수, 분쟁 해결 또는 계약 이행을 위해 필요한 기간 동안만 보관됩니다.",
    "a30": "로그 및 쿠키와 같은 사용 데이터는 내부 분석 및 보안 모니터링을 위해 합리적이고 규정을 준수하는 기간 동안 보관됩니다.",
    "a31": "6. 사용자 권리",
    "a32": "사용자는 아르헨티나 법률 25.326에 따라 다음과 같은 권리를 가집니다:",
    "a33": "개인정보 열람 요청",
    "a34": "부정확하거나 불완전한 정보의 정정 요청",
    "a35": "법적 근거가 없는 경우 개인정보 삭제 요청",
    "a36": "법적 범위 내에서 처리 거부 요청",
    "a37": "해당되는 경우 처리 제한 또는 데이터 이동 요청",
    "a38": "플랫폼은 이메일, 양식 또는 서면 요청을 통해 이러한 권리를 행사할 수 있는 명확한 채널을 제공합니다.",
    "a39": "7. 보안 조치",
    "a40": "플랫폼은 무단 접근, 유출, 오용, 변경 또는 파괴를 방지하기 위해 암호화, 접근 제어, 로그 모니터링 등 적절한 기술적 및 조직적 조치를 시행합니다.",
    "a41": "합리적인 보안 조치를 취하더라도 인터넷 환경의 특성상 절대적인 보안을 보장할 수는 없습니다.",
    "a42": "8. 정책 업데이트",
    "a43": "본 개인정보 처리방침은 주기적으로 업데이트될 수 있으며, 중요한 변경 사항은 플랫폼 또는 이메일을 통해 공지됩니다.",
    "a44": "업데이트된 정책은 게시 즉시 효력이 발생합니다.",
    "a45": "9. 준거법 및 감독 기관",
    "a46": "본 정책은 아르헨티나 법률의 적용을 받습니다.",
    "a47": "감독 기관: AAIP(공공정보접근청)"
  },
  "fwtk": {
    "a1": "1. 약관 동의",
    "a2": "사용자는 플랫폼을 방문하거나 이용하고, 계정을 생성하거나 거래를 수행하기 전에 본 약관을 반드시 읽고 전적으로 동의해야 합니다.",
    "a3": "사용자가 동의하지 않는 경우 플랫폼을 이용할 수 없습니다.",
    "a4": "2. 플랫폼 권리",
    "a5": "플랫폼은 사전 통지 없이 언제든지 서비스, 기능, 콘텐츠 또는 접근 권한을 수정, 중단 또는 종료할 수 있습니다.",
    "a6": "본 약관의 변경 사항은 게시 즉시 효력이 발생합니다.",
    "a7": "3. 합법적 이용 및 금지 행위",
    "a8": "사용자는 아르헨티나 법률, 신의성실 원칙 및 공공질서에 따라 플랫폼을 이용하는 것에 동의하며, 다음 행위는 금지됩니다:",
    "a9": "불법적인 목적 또는 제3자의 권리를 침해하는 행위;",
    "a10": "플랫폼 기능을 방해하거나 과도한 요청, 스팸, 자동화 스크립트, 봇, 크롤링 등을 수행하는 행위;",
    "a11": "타 사용자 계정 또는 민감 정보에 대한 무단 접근 또는 접근 시도;",
    "a12": "바이러스, 악성코드, 스파이웨어 또는 기타 유해한 코드 업로드 또는 유포;",
    "a13": "타인을 사칭하거나 허위 정보를 이용하여 계정을 생성하는 행위;",
    "a14": "허가 없이 계정 접근 권한을 재판매, 양도 또는 공유하는 행위;",
    "a15": "플랫폼의 승인 없이 광고, 마케팅 또는 상품/서비스 판매를 수행하는 행위;",
    "a16": "기타 법률, 플랫폼 규정 또는 본 약관을 위반하는 행위.",
    "a17": "위반 시 계정 정지 또는 해지 및 법적 책임이 발생할 수 있습니다.",
    "a18": "4. 면책 조항 및 위험 고지",
    "a19": "증권/주가 정보, 분석, 뉴스 또는 리서치 보고서 등은 참고용이며 투자, 법률 또는 세무 자문이 아닙니다.",
    "a20": "플랫폼을 통한 증권 거래 또는 금융 활동에서 발생하는 모든 위험은 사용자 본인이 부담합니다.",
    "a21": "플랫폼은 서비스 이용 또는 이용 불가로 인해 발생하는 직접적 또는 간접적 손해에 대해 책임을 지지 않습니다.",
    "a22": "5. 규정 준수 및 KYC/AML",
    "a23": "사용자는 신원 인증, 주소 증명, 자금 출처 또는 기타 규정 준수 문서를 제출해야 할 수 있습니다.",
    "a24": "플랫폼은 별도의 설명 없이 계정 개설을 거부하거나 거래를 중단할 수 있습니다.",
    "a25": "6. 개인정보 처리방침",
    "a26": "사용자는 개인정보가 개인정보 처리방침에 따라 수집 및 처리되는 것에 동의합니다.",
    "a27": "개인정보 처리방침과 본 약관은 함께 계약을 구성합니다.",
    "a28": "7. 준거법 및 분쟁 해결",
    "a29": "본 약관은 아르헨티나 법률에 따르며, 분쟁은 부에노스아이레스 일반 법원에 제기됩니다.",
    "a30": "8. 문의",
    "a31": "개인정보, 데이터 보호, 계정 또는 거래 관련 문의는 {value}로 연락해 주십시오."
  },
  "addDebitCard": {
    "a1": "은행 카드 추가",
    "a2": "예금주명",
    "a3": "예금주명을 입력해주세요",
    "a4": "은행명",
    "a5": "은행명을 입력해주세요",
    "a6": "{value} 22자리 계좌번호를 입력해주세요",
    "a7": "계좌 유형",
    "a8": "계좌 유형을 입력해주세요",
    "a9": "제출",
    "c1": "카드 등록 완료",
    "c2": "22자리 숫자여야 합니다",
    "c3": "은행 주소",
    "c4": "은행 주소를 입력해 주세요",
    "c5": "은행 계좌 번호",
    "c6": "은행 계좌 번호를 입력해 주세요",
    "c7": "SWIFT 코드를 입력해 주세요"
  },
  "asset": {
    "a1": "총 자산",
    "a2": "시가 평가액",
    "a3": "사용 가능 잔액",
    "a4": "동결 금액",
    "a5": "총 수익",
    "a6": "입금",
    "a7": "출금",
    "a8": "자산 전환",
    "a9": "자금 내역",
    "a10": "자금 비밀번호",
    "a11": "대출 신청",
    "a12": "입금 방식",
    "a13": "출금 방식",
    "c1": "실명 인증이 필요합니다",
    "c2": "지금 인증하기",
    "c3": "취소",
    "c4": "출금을 위해 실명 인증이 필요합니다. 지금 인증하시겠습니까?",
    "c5": "인증 상태 확인",
    "c6": "인증이 진행 중입니다. 승인 후 출금해 주세요."
  },
  "assetConversion": {
    "a1": "자산 전환",
    "a2": "자금 기록",
    "a3": "출금 통화",
    "a4": "사용 가능 잔액",
    "a5": "금액을 입력하세요",
    "a6": "전환할 통화를 선택하세요",
    "a7": "입금 통화",
    "a8": "현재 잔액:",
    "a9": "수령 금액",
    "a10": "실제 금액은 변동될 수 있습니다",
    "a11": "지금 제출"
  },
  "dayTrading": {
    "a1": "AI 트레이딩",
    "a2": "주문 제출 완료",
    "a3": "신청 완료",
    "a4": "거래 중",
    "a5": "거래 상세",
    "a6": "참여 기간:",
    "a7": "금액 입력 (최소 {value})",
    "a8": "제출",
    "a9": "주문 번호",
    "a10": "주문 상태",
    "a11": "검토 대기",
    "a12": "주문 금액",
    "a13": "거부됨",
    "a14": "주문 번호",
    "a15": "주문 상태",
    "a16": "종료됨",
    "a17": "거래 유형",
    "a18": "매수(롱)",
    "a19": "청산 시간",
    "a20": "수량",
    "a21": "매수가",
    "a22": "총 매수 금액",
    "a23": "수수료",
    "a24": "매도가",
    "a25": "총 매도 금액",
    "a26": "수익 금액",
    "a27": "확인",
    "a28": "취소",
    "a29": "상품 소개",
    "a30": "아르헨티나 종합 주가지수를 기반으로 AI 기반 분산 투자 전략을 활용하여 안정적인 리스크 관리와 지속적인 성장을 추구합니다.",
    "a31": "본 펀드는 미국의 가장 규모가 크고 유동성이 높은 30개 종목에 집중하며, 동일 가중 전략으로 리스크를 분산합니다.",
    "a32": "5일 투자, 일일 예상 수익률 1.5~3%.",
    "a33": "국영 및 주요 석유·가스 기업에 집중합니다.",
    "a34": "예상 수익률",
    "a39": "투자 전략",
    "a40": "거래 주기",
    "a41": "총 수익률: {value}",
    "a42": "투자 금액",
    "a43": "사용 가능 잔액: {value}",
    "a44": "최소 한도 {value}",
    "a45": "잔액 부족",
    "c1": "금액을 입력해야 합니다",
    "a35": "{value}만 페소 투자 기준, 1~3 거래일 동안 일일 0.5%~1% 수익률 예상, 일 평균 약 {value2} 페소 수익.",
    "a36": "{value}만 페소 투자 기준, 1~3 거래일 동안 일일 1%~1.5% 수익률 예상, 일 평균 약 {value2} 페소 수익.",
    "a37": "{value}만 페소를 5 거래일 투자 시, 일일 1.5%~2% 수익률 예상, 일 평균 {value2}만 페소 수익.",
    "a38": "{value}만 페소를 7 거래일 투자 시, 일일 3%~5% 수익률 예상, 일 평균 {value2}만 페소 수익.",
    "b1": "{value}일"
  },
  "etf": {
    "a1": "상품 환매",
    "a2": "주문 내역",
    "a3": "주문 번호",
    "a4": "상품",
    "a5": "주기(일)",
    "a6": "매수 시간",
    "a7": "만기 시간",
    "a8": "투자 금액",
    "a9": "총 예상 수익",
    "a10": "보유 일수",
    "a11": "지급 금액",
    "a12": "상태",
    "a13": "환매 완료",
    "c1": "대기 중",
    "c2": "거래 중",
    "c3": "거래 비밀번호"
  },
  "fundAccountManage": {
    "a1": "자금 계좌 관리",
    "a2": "은행 카드 추가",
    "a3": "은행 카드 관리",
    "a4": "주소 바인딩",
    "a5": "주소 유형",
    "a6": "주소",
    "a7": "삭제 확인",
    "a8": "확인",
    "a9": "취소",
    "a10": "이 카드를 삭제하시겠습니까?",
    "a11": "ERC 주소를 입력해야 합니다",
    "a12": "TRC 주소를 입력해야 합니다",
    "a13": "바인딩된 주소를 수정하려면 고객센터로 문의하세요",
    "a14": "ERC20 주소",
    "a15": "TRC20 주소"
  },
  "fundingRecords": {
    "a1": "자금 기록",
    "a2": "매수 상세",
    "a3": "입금 금액",
    "a4": "출금",
    "a5": "전환",
    "a6": "입금 완료",
    "a7": "요청 금액",
    "a8": "실제 입금 금액",
    "a9": "금액",
    "a10": "시간",
    "a11": "수익",
    "a12": "지출",
    "a13": "충전 금액",
    "a14": "미완료",
    "a15": "완료",
    "a16": "취소됨",
    "a17": "검토 대기",
    "a18": "입금 완료",
    "a19": "검토 실패",
    "a20": "출금 환불"
  },
  "fundPassword": {
    "a1": "자금 비밀번호",
    "a2": "기존 비밀번호",
    "a3": "기존 비밀번호를 입력하세요",
    "a4": "새 비밀번호",
    "a5": "새 비밀번호를 입력하세요",
    "a6": "비밀번호 확인",
    "a7": "확인 비밀번호를 입력하세요",
    "a8": "지금 제출",
    "a9": "6자리 숫자 비밀번호를 입력하세요",
    "a10": "6자리여야 합니다",
    "a11": "비밀번호",
    "a12": "확인 비밀번호를 입력하세요",
    "a13": "두 비밀번호가 일치하지 않습니다"
  },
  "index": {
    "a1": "블록 트레이드",
    "a2": "데이 트레이딩",
    "a3": "KYC 인증",
    "a4": "온라인 지원",
    "a5": "글로벌 지수",
    "a6": "더보기",
    "a7": "인기 종목",
    "a8": "관심종목",
    "a9": "아르헨티나",
    "a10": "미국 주식",
    "a11": "종목 / 코드",
    "a12": "최신가 ({value})",
    "a13": "변동률",
    "a14": "스마트 트레이딩 시스템",
    "a15": "10년간의 히스토리컬 백테스트를 기반으로 한 딥러닝 모델 적용",
    "a16": "빠르고 안전하며 유연한 블록 트레이딩",
    "a17": "대량 거래 할인",
    "a18": "주요 뉴스",
    "a19": "회사 소개",
    "a20": "자주 묻는 질문",
    "a21": "데이터 없음",
    "a22": "체험 자금을 받으려면 KYC 인증을 완료하세요",
    "a23": "KYC 인증",
    "a24": "축하합니다! KYC 인증이 승인되었습니다. 체험 자금이 지급되었습니다.",
    "a25": "투자 시작",
    "a26": "AI 자동 투자",
    "a27": "수익 보기",
    "a28": "최신가",
    "a29": "현재 포지션 보유 중",
    "a30": "포지션 종료",
    "a31": "사용 가능 자금"
  },
  "ipo": {
    "a1": "IPO 청약",
    "a2": "청약 완료",
    "a3": "거래 중",
    "a4": "상세 정보",
    "a5": "자동 청약",
    "a6": "미배정",
    "a7": "청약 수량",
    "a8": "배정 시간",
    "a9": "배정 수량",
    "a10": "예상 수익",
    "a11": "결제 예정 금액",
    "a12": "결제 완료",
    "a13": "공모가",
    "a14": "시장가",
    "a15": "종료됨",
    "a16": "배정 대기",
    "a17": "배정 완료",
    "a18": "거절됨",
    "a19": "거래 비밀번호",
    "a20": "상품 상세",
    "a21": "발행 수량",
    "a22": "발행가",
    "a23": "종목 코드",
    "a24": "환율",
    "a25": "마감일",
    "a26": "지금 청약",
    "a27": "주문 번호",
    "a28": "마감일",
    "a29": "지금 결제",
    "a30": "당첨 가격",
    "a31": "당첨 주식 수",
    "a32": "총 당첨 금액",
    "a33": "총 수익",
    "a34": "상장일",
    "a35": "출시일",
    "a36": "거절 사유",
    "a37": "검토 대기",
    "a38": "결제 대기",
    "a39": "상장 대기",
    "a40": "포지션 종료",
    "a41": "거절됨",
    "a42": "청약 완료",
    "a43": "마감되었습니다.",
    "a44": "환매"
  },
  "login": {
    "a1": "휴대폰 번호 입력",
    "a2": "비밀번호 입력",
    "a3": "온라인 지원",
    "a4": "비밀번호를 잊으셨나요?",
    "a5": "보안 로그인",
    "a6": "계정이 없으신가요?",
    "a7": "회원가입",
    "a8": "로그인",
    "a9": "다시 오신 것을 환영합니다! 로그인해 주세요.",
    "a10": "잘못된 휴대폰 번호 형식입니다",
    "a11": "로그인 성공"
  },
  "register": {
    "a1": "비밀번호 재입력",
    "a2": "초대 코드 (필수)",
    "a3": "이미 계정이 있으신가요?",
    "a4": "로그인",
    "a5": "보안 회원가입",
    "a6": "회원가입",
    "a7": "새 계정 생성",
    "a8": "휴대폰 번호 입력",
    "a9": "잘못된 휴대폰 번호 형식입니다",
    "a10": "비밀번호 입력",
    "a11": "영문과 숫자를 포함하여 최소 6자 이상",
    "a12": "비밀번호 확인 입력",
    "a13": "비밀번호가 일치하지 않습니다",
    "a14": "초대 코드 입력",
    "a15": "신분증 번호를 입력하세요",
    "a16": "먼저 약관에 동의해 주세요.",
    "a17": "동의",
    "a18": "회원가입 약관",
    "a19": "회원가입 안내",
    "a20": "동의"
  },
  "mail": {
    "a1": "알림",
    "a2": "삭제",
    "a3": "시스템 공지",
    "a4": "주문 알림",
    "a5": "주문 번호",
    "a6": "심사 결과",
    "a7": "체험 자금 알림",
    "a8": "개인 메시지",
    "a9": "통화",
    "a10": "시장 가격",
    "a11": "매수 가격",
    "a12": "만료 시간",
    "a13": "통과"
  },
  "market": {
    "a1": "종목명 입력",
    "a2": "검색",
    "a3": "관심종목",
    "a4": "아르헨티나 주식",
    "a5": "미국 주식",
    "a6": "뉴스",
    "a7": "종목 / 코드",
    "a8": "최신가",
    "a9": "변동률",
    "a10": "최신가",
    "a11": "상세 보기",
    "a12": "상승",
    "a13": "하락",
    "a14": "중립",
    "a15": "홍콩 주식",
    "a16": "펀드",
    "a17": "선물",
  },
  "marketDetail": {
    "a1": "시장",
    "a2": "시가",
    "a3": "전일 종가",
    "a4": "고가",
    "a5": "저가",
    "a6": "매수",
    "a7": "총 매수 금액",
    "a8": "사용 가능 자금",
    "a9": "총 자금",
    "a10": "레버리지",
    "a11": "매수 수량",
    "a12": "수량 입력",
    "a13": "이익 실현 가격",
    "a14": "이익 실현 가격 입력",
    "a15": "손절 가격",
    "a16": "손절 가격 입력",
    "a17": "확인",
    "a18": "시간:",
    "a19": "시가:",
    "a20": "종가:",
    "a21": "저가:",
    "a22": "고가:",
    "a23": "현재가",
    "a24": "이익 실현 설정",
    "a25": "손절 설정",
    "a26": "최대 매수 가능",
    "a27": "주",
    "a28": "매수 수량 입력",
    "a29": "손절 가격 입력",
    "a30": "손절 가격은 현재가보다 높을 수 없습니다",
    "a31": "이익 실현 가격 입력",
    "a32": "이익 실현 가격은 현재가보다 낮을 수 없습니다"
  },
  "mine": {
    "a1": "인증 완료",
    "a2": "사용 가능 자금",
    "a3": "사용 가능 자금",
    "a4": "KYC 인증",
    "a5": "로그인 비밀번호 변경",
    "a6": "자금 관리",
    "a7": "온라인 지원",
    "a8": "언어 전환",
    "a9": "로그아웃",
    "a10": "심사 중",
    "a11": "거절됨",
    "a12": "미인증",
    "a13": "안티 사기 구역",
    "a14": "규제 정보",
    "a15": "위험 고지"
  },
  "newsDetail": {
    "a1": "뉴스"
  },
  "otc": {
    "a1": "주문 제출 완료",
    "a2": "검토 대기",
    "a3": "거래 상세",
    "a4": "거절됨",
    "a5": "시장가",
    "a6": "할인 가격",
    "a7": "주당 수익",
    "a8": "최소 매수 수량",
    "a9": "수량 입력",
    "a10": "총 매수 금액",
    "a11": "사용 가능 잔액",
    "a12": "확인",
    "a13": "검토 대기",
    "a14": "매수 시간",
    "a15": "수량",
    "a16": "시장가",
    "a17": "할인 가격",
    "a18": "총 자금",
    "a19": "종료됨",
    "a20": "거절됨",
    "a21": "대량 할인",
    "a22": "상품 청약",
    "a23": "배정됨",
    "a24": "거래 상세",
    "a25": "거절됨",
    "a26": "청약 가격",
    "a27": "현재가",
    "a28": "프리미엄",
    "a29": "게시 시간",
    "a30": "마감일",
    "a31": "청약 완료",
    "a32": "지금 청약",
    "a33": "결제 대기",
    "a34": "주문 번호",
    "a35": "청약 가격",
    "a36": "배정 주식",
    "a37": "총 청약 금액",
    "a38": "결제 완료",
    "a39": "미결제",
    "a40": "예상 수익",
    "a41": "청약 시간",
    "a42": "지금 결제",
    "a43": "보유 중",
    "a44": "시작 시간",
    "a45": "종료 시간",
    "a46": "환매",
    "a47": "거절 사유",
    "a48": "청약 확인",
    "a49": "확인",
    "a50": "취소",
    "a51": "지금 청약하여 더 많은 수익을 얻으세요! 청약하시겠습니까?",
    "a52": "결제 확인",
    "a53": "지금 결제하여 더 많은 수익을 얻으세요! 결제하시겠습니까?",
    "a54": "환매 확인",
    "a55": "즉시 환매하시겠습니까?",
    "a56": "매도 확인",
    "a57": "계속 보유하면 더 많은 수익을 얻을 수 있습니다. 매도하시겠습니까?",
    "c1": "청약 성공",
    "c2": "결제 마감 시간"
  },
  "positionDetails": {
    "a1": "거래 상세",
    "a2": "종료됨",
    "a3": "주문 번호",
    "a4": "매도가",
    "a5": "매도 시간",
    "a6": "매수 시간",
    "a7": "거래 유형",
    "a8": "매수(롱)",
    "a9": "청산 수량",
    "a10": "매수가",
    "a11": "계약 금액",
    "a12": "수수료",
    "a13": "청산 수수료",
    "a14": "시장가",
    "a15": "실제 손익",
    "a16": "수익률",
    "a17": "레버리지"
  },
  "realNameAuthentication": {
    "a1": "KYC 인증",
    "a2": "승인됨",
    "a3": "신원 인증",
    "a4": "앞면 업로드",
    "a5": "뒷면 업로드",
    "a6": "성명",
    "a7": "성명을 입력하세요",
    "a8": "신분증 번호",
    "a9": "8자리 신분증 번호를 입력하세요",
    "a10": "제출",
    "a11": "인증 완료",
    "a12": "심사 중",
    "a13": "심사 실패, 다시 제출해 주세요",
    "a14": "전화번호",
    "a15": "전화번호를 입력하세요",
    "a16": "이메일",
    "a17": "이메일 입력 (선택 사항)",
    "a18": "신분증을 업로드해 주세요",
    "a19": "성명을 입력해 주세요",
    "a20": "신분증 번호를 입력해 주세요",
    "a21": "전화번호를 입력해 주세요",
    "a22": "올바르지 않은 이메일 형식",
    "a23": "신분증 번호는 11자리여야 합니다",
    "a24": "전화번호는 10자리여야 합니다",
    "c1": "알림",
    "c2": "확인",
    "c3": "제출이 완료되었습니다. 심사를 기다려 주세요!",
    "c4": "거절 사유"
  },
  "topUp": {
    "a1": "충전",
    "a2": "복사",
    "a3": "충전 금액",
    "a4": "금액을 입력하세요",
    "a5": "최소",
    "a6": "결제 금액",
    "a7": "수수료",
    "a8": "실제 금액",
    "a9": "다른 결제 채널이 필요하시면 고객센터로 문의해 주세요",
    "a10": "고객센터 문의",
    "a11": "알림",
    "a12": "고객센터 문의",
    "a13": "취소",
    "a14": "현재 이체가 제한되어 있습니다. 오전 9시부터 오후 10시 사이에 거래를 완료해 주세요. 문의 사항이 있으시면 고객센터로 연락하시거나 가상화폐로 충전해 주세요.",
    "a15": "최소 충전 금액은",
    "a16": "충전 금액을 입력하세요",
    "a17": "결제 페이지 로딩 중...",
    "a18": "충전",
    "a19": "다른 결제 채널이 필요하시면 고객센터로 문의해 주세요",
    "a20": "참고: 해당 채널은 { value } 체인 암호화폐 충전만 지원하며, 최소 충전 금액은 { value2 }입니다",
    "a22": "복사 성공"
  },
  "transaction": {
    "a1": "아르헨티나",
    "a2": "미국 주식",
    "a3": "검색 키워드를 입력하세요",
    "a4": "검색",
    "a5": "청약",
    "a6": "ETF 보유",
    "a7": "진행 중",
    "a8": "종료됨",
    "a9": "시가총액 {value}",
    "a10": "사용 가능 자금 {value}",
    "a11": "손익 {value}",
    "a12": "미당첨",
    "a13": "종료됨",
    "a14": "예상 수익",
    "a15": "청약 가격 {value}",
    "a16": "청약 수량",
    "a17": "배정일",
    "a18": "당첨",
    "a19": "지불 완료 {value}",
    "a20": "결제 대기 {value}",
    "a21": "종목명",
    "a22": "현재가 {value}",
    "a23": "원가 {value}",
    "a24": "보유 중",
    "a25": "시가",
    "a26": "손익",
    "a27": "포지션 보유",
    "a28": "수익률",
    "a29": "매수 시간",
    "a30": "만료 시간",
    "a31": "펀드명",
    "a32": "매수 금액",
    "a33": "일일 수익",
    "a34": "일일 수익률",
    "a35": "총 수익",
    "a36": "총 수익률",
    "a37": "거래 주기",
    "a38": "종목명",
    "a39": "매도 가격 {value}",
    "a40": "청산 수량",
    "a41": "손익",
    "a42": "손익",
    "a43": "종료됨",
    "a44": "AI 트레이딩",
    "a45": "블록 할인",
    "a46": "주식",
    "a47": "포지션 보유",
    "a48": "주문 번호",
    "a49": "청약 가격",
    "a50": "배정 주식",
    "a51": "총 청약 금액",
    "a52": "지불 완료",
    "a53": "결제 대기",
    "a54": "예상 수익",
    "a55": "시작 시간",
    "a56": "만료 시간",
    "a57": "상환",
    "a58": "수익",
    "a59": "매도",
    "a60": "거래 중",
    "a61": "거래 주기",
    "a62": "일",
    "a63": "예상 수익",
    "a64": "만료 시간",
    "a65": "청약 시간",
    "a66": "상환 확인",
    "a67": "확인",
    "a68": "취소",
    "a69": "지금 상환하시겠습니까?",
    "a70": "매도 확인",
    "a71": "지금 매도하시겠습니까?",
    "d1": "포지션 청산",
    "d2": "익절",
    "d3": "손절"
  },
  "updateLoginPassword": {
    "a1": "로그인 비밀번호 변경",
    "a2": "현재 비밀번호",
    "a3": "현재 비밀번호를 입력하세요",
    "a4": "새 비밀번호",
    "a5": "새 비밀번호를 입력하세요",
    "a6": "비밀번호 확인",
    "a7": "비밀번호를 확인해 주세요",
    "a8": "지금 제출",
    "a9": "영문과 숫자를 포함하여 최소 6자 이상이어야 합니다",
    "a10": "비밀번호가 일치하지 않습니다"
  },
  "withdrawal": {
    "a1": "출금",
    "a2": "사용 가능 자금",
    "a3": "은행 카드",
    "a4": "은행 카드를 선택해 주세요",
    "a5": "출금 금액을 입력하세요",
    "a6": "제출",
    "a7": "은행 카드를 선택해 주세요",
    "a8": "지금 연결",
    "a9": "확인",
    "a10": "실제 수령 금액",
    "a11": "수수료",
    "a12": "보안 안내",
    "a13": "확인",
    "a14": "먼저 거래 비밀번호를 설정해 주세요",
    "a15": "제출 완료되었습니다. 은행 채널이 혼잡하여 자금은 24시간 이내에 입금됩니다",
    "a16": "은행 카드를 선택해 주세요",
    "a17": "출금 금액을 입력하세요",
    "a18": "최소 출금 금액",
    "c1": "제출 완료"
  },
  "notifyPopupOtc": {
    "a1": "블록 할인 청약 알림",
    "a2": "청약 대기 중인 블록 할인 상품이 여러 개 있습니다",
    "a3": "청약 대기 중인 블록 할인 상품이 1개 있습니다",
    "a4": "종목명:",
    "a5": "청약 가격:",
    "a6": "시장 가격:",
    "a7": "통화:",
    "a8": "마감일:",
    "a10": "종목 유형:",
    "a11": "매수 가격:",
    "a12": "주식 수:",
    "a13": "종목 거래 코드:",
    "a14": "주문 번호:",
    "a15": "결제 시간:",
    "a16": "회사명:",
    "a17": "종목 유형:",
    "a18": "금액:",
    "a19": "주문 번호:",
    "a20": "심사 상태:",
    "a21": "사용자 메모:",
    "a9": "종목명:",
    "d1": "여러 블록 주문이 성공적으로 배정되었습니다",
    "d2": "하나의 블록 주문이 성공적으로 배정되었습니다",
    "d3": "블록 주문 알림",
    "d4": "여러 블록 주문이 거절되었습니다",
    "d5": "하나의 블록 주문이 거절되었습니다",
    "d6": "블록 주문 거절 알림",
    "d7": "거절됨"
  },
  "tyjPopup": {
    "a1": "체험 보너스",
    "a2": "남은 수령 시간",
    "a3": "체험 보너스",
    "a4": "확인",
    "a5": "축하합니다, 신원 인증이 승인되었습니다",
    "a6": "수령 금액",
    "a7": "체험 보너스",
    "a8": "이벤트 카운트다운",
    "a9": "지금 투자"
  },
  "aiTransactionDetails": {
    "a1": "거래 상세",
    "a2": "날짜",
    "a3": "일일 수익",
    "a4": "종목 상세",
    "a5": "매수 가격",
    "a6": "매도 가격",
    "a7": "보유 수량",
    "a8": "일일 수익",
    "c1": "스마트 트레이딩..."
  },
  "aiTransactionRecords": {
    "a1": "AI 거래 기록",
    "a2": "거래 중",
    "a3": "거래 상세",
    "a4": "거래 주기",
    "a5": "예상 수익",
    "a6": "만료 시간",
    "a7": "청약 시간",
    "a8": "상세 보기",
    "a9": "일",
    "c1": "대기 중",
    "c2": "거래 중",
    "c3": "종료됨",
    "c4": "작업 실패"
  },
  "fqa": {
    "a1": "자주 묻는 질문",
    "a2": "Matrix는 아르헨티나 정부의 초청을 받아 운영되며, 세계 두 번째 규모의 거래소인 NASDAQ 기반으로 거래를 진행하며 SEC 및 FINRA의 엄격한 규제를 받습니다.",
    "a3": "현재 초기 프로모션 기간 동안 거래 수수료는 무료입니다. 출금 수수료는 1~0.3%이며, 환율은 아르헨티나 페소와 USD 기준을 따릅니다.",
    "a4": "입금 수수료는 없습니다. 대규모 입금은 사전 통지가 필요합니다. 모든 작업은 정부 및 은행의 규제를 받습니다.",
    "a5": "시장 변동은 정상이며, 위험과 수익이 공존합니다. 회사는 AI 트레이딩 및 블록 할인 전략을 제공합니다.",
    "a6": "플랫폼은 실시간 아르헨티나 및 미국 시장 데이터를 사용합니다.",
    "a7": "SEC 및 FINRA의 규제를 받으며, 출금에는 정상적인 수수료가 발생합니다.",
    "a8": "사용자는 개인 정보 및 은행 카드를 바인딩할 수 있습니다. 거래 실패는 시장 요인으로 회사와 무관합니다.",
    "a9": "사용자는 정상적으로 플랫폼을 이용하고 시장 위험을 이해해야 합니다. KYC 인증이 필요합니다.",
    "a11": "1. 플랫폼은 합법적이며 규제를 받습니까?",
    "a12": "2. 거래 수수료, 커미션, 환율 비용은 어떻게 됩니까?",
    "a13": "3. 입출금은 안전합니까?",
    "a14": "4. 시장/유동성/변동성 위험은 무엇입니까?",
    "a15": "5. 데이터는 정확합니까?",
    "a16": "6. 법적 및 세금 책임은 무엇입니까?",
    "a17": "7. 자금은 안전합니까? 문제 발생 시 어떻게 해결합니까?",
    "a18": "8. 사용자는 어떻게 플랫폼을 이용해야 합니까?"
  },
  "loan": {
    "a1": "대출 신청",
    "a2": "전화번호",
    "a3": "전화번호를 입력하세요",
    "a4": "잘못된 전화번호 형식",
    "a5": "이름",
    "a6": "이름을 입력하세요",
    "a7": "이메일",
    "a8": "이메일을 입력하세요",
    "a9": "금액",
    "a10": "대출 금액을 입력하세요",
    "a11": "대출 자격이 없습니다. 고객센터로 문의해 주세요."
  },
  "loanRecords": {
    "a1": "대출 기록",
    "a2": "차입자",
    "a3": "심사 대기",
    "a4": "승인됨",
    "a5": "거절됨"
  },
  "withdrawalu": {
    "a1": "출금 주소",
    "a2": "실제 수령 금액",
    "a3": "수수료",
    "a4": "바인딩 안내",
    "a5": "확인",
    "a6": "먼저 TRC 출금 주소를 바인딩해 주세요",
    "a7": "보안 안내",
    "a8": "먼저 거래 비밀번호를 설정해 주세요",
    "a9": "출금 주소는 비워둘 수 없습니다",
    "a10": "출금 금액을 입력하세요",
    "a11": "최소 출금 금액",
    "a12": "먼저 ERC 출금 주소를 바인딩해 주세요"
  },
  "about": {
    "a1": "우리는 초기 단계부터 시리즈 A까지 투자하는 벤처 캐피탈입니다. 우리 팀은 Apple, FedEx, Oculus, Canva 등에서 활동한 창업자 및 빌더 출신으로 구성되어 있습니다.",
    "a2": "우리는 역발상 투자자로서, 깊은 기술 전문성과 강력한 비전을 가진 창업자를 지원합니다.",
    "a3": "팀",
    "a4": "우리는 창업자와 빌더 출신으로 구성된 긴밀한 팀입니다. 투자를 신중히 선택하고 깊이 있게 관여합니다.",
    "a5": "초기 단계에서 참여하여 장기적으로 함께합니다.",
    "a6": "투자",
    "a7": "Ilya Sukhan",
    "a8": "AI, 인프라",
    "a9": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
    "a10": "Dana Stalder",
    "a11": "핀테크, B2B",
    "a12": "ApartmentList, Baselane, EarnIn, Flexible Finance, Mudflap, Side, Steadily, Zest AI",
    "a13": "Antonio Rodriguez",
    "a14": "AI, 프론티어 테크",
    "a15": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
    "a16": "Kojo Osei",
    "a17": "AI, 인프라",
    "a18": "Hookdeck, Ampersand, LM Studio",
    "a19": "프로젝트",
    "a20": "도전가, 혁신가, 탐험가들로 구성된 포트폴리오 기업은 비전과 기술력을 갖춘 창업자들이 설립했습니다.",
    "a21": "문의 — 지금이 가장 빠른 시점입니다",
    "a22": "샌프란시스코",
    "a23": "535 Mission St, Suite 2600, San Francisco, CA 94105, 전화: 650-798-1600",
    "a24": "보스턴",
    "a25": "101 Main St, 17th Floor, Cambridge, MA 02142, 전화: 617-494-1223"
  },
  "AiTrialBonus": {
    "a1": "체험 자금 받기",
    "a2": "AI 알고리즘 분석 + 전문 리스크 관리로 모든 투자를 투명하고 안전하게 관리하며 자산을 보호합니다",
    "a3": "체험 보너스 받기",
    "a4": "AI 투자 시작",
    "a5": "수익 창출",
    "a6": "체험 전략",
    "a7": "투자 주기",
    "a8": "예상 수익률",
    "a9": "체험 보너스",
    "a10": "제출",
    "a11": "내 수익",
    "a12": "현재 총 투자 수익",
    "a13": "일일 수익",
    "a14": "매수",
    "a15": "매도",
    "a16": "보유 수량",
    "a17": "수익",
    "a18": "수익 대기 중",
    "a19": "이벤트 알림",
    "a20": "뒤로",
    "a21": "이 이벤트는 종료되었습니다!",
    "b1": "AI로 미래의 부를 창출",
    "b2": "일"
  },
  "notifyPopupKyc": {
    "a1": "회원가입을 축하합니다! 신원 인증을 완료해 주세요!",
    "a2": "인증하러 가기"
  },
  "store": {
    "a1": "인증 알림",
    "a2": "지금 인증",
    "a3": "취소",
    "a4": "거래를 위해 인증이 필요합니다. 지금 인증하시겠습니까?",
    "a5": "인증 보기",
    "a6": "인증 심사 중으로 현재 거래가 불가능합니다!"
  },
  "newRouter": {
    "a1": "먼저 로그인해 주세요",
    "a2": "로그인 중...",
    "a3": "회원가입 중..."
  },
  "utils": {
    "a1": "{value}일 {value2}시간 {value3}분 {value4}초"
  },
  "oneStocks": {
    "a1": "최고가",
    "a2": "최저가",
    "a3": "평균가",
    "a4": "거래량",
    "a5": "전일 시가",
    "a6": "전일 종가",
    "a7": "변동성",
    "a8": "고할인",
    "a9": "거래하기",
    "a10": "당일",
    "a11": "일간",
    "a12": "주간",
    "a13": "월간",
    "a14": "분기",
    "a15": "연간"
  },
  "antiFraud": {
    "a1": "사기 방지 구역",
    "a2": "사기 식별",
    "a3": "문자/메시지의 공식 링크 또는 연락처를 복사하여 확인하세요. 비공식 링크를 클릭하거나 계정 비밀번호를 입력하지 마세요.",
    "a4": "제출",
    "a5": "중요 공지",
    "a6": "사기 신고 채널",
    "a7": "유령 회사 사기",
    "a8": "'펌프 앤 덤프' 또는 '고가 유도 판매' 사기",
    "a9": "'공매도 유도 자금 축적' 사기",
    "a10": "연금 계좌 사기",
    "a11": "지인 사칭 사기",
    "a12": "당사는 귀하의 개인정보 보안을 엄격히 보호합니다.",
    "a13": "귀하의 신뢰는 매우 중요합니다. 개인정보의 중요성을 인지하고 있으며, 관련 법규에 따라 엄격한 보안 조치를 통해 보호합니다. 자세한 내용은 아래 '개인정보 보호정책' 및 '서비스 약관'을 참고하십시오.",
    "a14": "개인정보 보호정책",
    "a15": "서비스 약관",
    "a16": "검증 내용은 비워둘 수 없습니다",
    "a17": "제출이 완료되었습니다! 고객센터의 연락을 기다려 주세요",
    "a18": "사기 신고 채널",
    "a19": "FBI — 범죄 신고 센터",
    "a20": "영국 국가 사기 및 사이버 범죄 신고 센터",
    "a21": "대한민국 경찰청",
    "a22": "일본 경찰청",
    "a23": "유럽연합",
    "a24": "상세 정보",
    "a25": "누구나 금융 사기의 대상이 될 수 있습니다. 가장 좋은 방어는 정보를 숙지하고 경계하는 것입니다. 아래는 주요 금융 사기 유형과 예방 팁입니다.",
    "a26": "유령 회사 사기",
    "a27": "사기범은 합법적인 회사를 사칭하여 자금을 이체하도록 유도합니다. 일부 경우 금융기관 직원 등을 사칭하기도 합니다.",
    "a28": "펌프 앤 덤프 사기",
    "a29": "허위 정보를 퍼뜨려 주가를 인위적으로 상승시킨 후 고가에 매도하여 투자자에게 손실을 입히는 방식입니다.",
    "a30": "공매도 축적 사기",
    "a31": "허위 정보를 퍼뜨려 주가 하락을 유도한 후 저가 매수하는 방식입니다.",
    "a32": "연금 계좌 사기",
    "a33": "세금 회피 등을 미끼로 연금 자금을 빼돌리는 사기입니다.",
    "a34": "지인 기반 신뢰 사기",
    "a35": "비슷한 배경을 이용해 신뢰를 얻고 허위 투자로 유도하는 방식입니다.",
    "a36": "지인 대상 사기는 대부분 다단계 또는 폰지 구조로, 신규 자금으로 기존 투자자에게 지급됩니다."
  },
  "Regulatorynfo": {
    "a0": "규제 정보",
    "a1": "미국 증권거래위원회(SEC)에 등록되었으며 FINRA 회원입니다. 고객 자산은 회사 자산과 분리 보관됩니다. FATCA / W-8BEN 규정 준수.",
    "a2": "FINRA 및 SIPC 회원. 최대 $500,000까지 보호 (현금 $250,000 포함). FDIC 보장 없음 • 은행 보증 없음 • 원금 손실 가능 © 2026 Matrix Quant Inc."
  },
  "riskDisclosure": {
    "a0": "위험 고지",
    "a1": "모든 투자는 위험을 수반하며 모든 투자자에게 적합하지 않을 수 있습니다.",
    "a2": "투자 원금의 일부 또는 전부를 잃을 수 있습니다.",
    "a3": "과거 수익은 미래 수익을 보장하지 않습니다.",
    "a4": "시장 변동성 및 경제 상황이 자산 가격에 영향을 줄 수 있습니다.",
    "a5": "마진 거래 위험",
    "a6": "마진 거래는 높은 위험을 수반합니다.",
    "a7": "예치금 이상의 손실이 발생할 수 있습니다.",
    "a8": "증권사는 사전 통보 없이 강제 청산할 수 있습니다.",
    "a9": "마진콜 연장은 보장되지 않습니다.",
    "a10": "옵션 거래 위험",
    "a11": "옵션은 높은 위험을 수반합니다.",
    "a12": "거래 전 옵션 위험 설명서를 확인하십시오.",
    "a13": "프리미엄 전액 손실 가능",
    "a14": "옵션 매도 시 무제한 손실 가능",
    "a15": "데이 트레이딩 위험",
    "a16": "단기 매매는 큰 손실을 초래할 수 있습니다.",
    "a17": "패턴 데이 트레이더는 최소 $25,000 유지 필요",
    "a18": "잦은 거래는 높은 비용 발생 가능",
    "a19": "시스템 문제로 거래 지연 가능",
    "a20": "급변 시장에서 슬리피지 발생 가능",
    "a21": "규제 공지",
    "a22": "MatrixQuant Inc는 SEC 등록 및 FINRA, SIPC 회원입니다."
  }
};